import { createContext, PropsWithChildren, useContext, useEffect, useState } from 'react';

import { Loader } from '@/components/core/Loader';
import { getInjector } from '@/services/angularjs-bridge';
import { User } from '@/types/User';

interface UserContextInterface {
    user?: User;
}

const UserContext = createContext<UserContextInterface | undefined>(undefined);

const useUser = () => {

    const userContext = useContext(UserContext);

    if (!userContext) {
        throw new Error('useUser must be used within an UserProvider');
    }

    return userContext;
};

const UserProvider = ({ children }: PropsWithChildren) => {

    const [user, setUser] = useState<User | undefined>(undefined);

    useEffect(() => {
        // Grab $rootScope from the angularjs world
        const angularJSInjector = getInjector();
        const $rootScope = angularJSInjector.get('$rootScope');
        setUser($rootScope.user);
    }, []);

    if (!user) {
        return <Loader />;
    } else {
        return <UserContext.Provider value={{ user }}>{children}</UserContext.Provider>;
    }

};

export { UserContext, UserProvider, useUser };
